module.exports = __webpack_public_path__ + "img/cliu4.de59b7e6.png";